module.exports = __webpack_public_path__ + "img/woocommerce.c5a7bdd6.jpg";